import React from 'react'
import styled, { withTheme } from 'styled-components'
import { inject, observer } from 'mobx-react'
import { Navigate } from 'react-router-dom'
import LoginBox from '../components/Login/LoginBox'
import ContactInfos from '../components/ContactInfos/ContactInfos'
import PasswordResetBox from '../components/Login/PasswordResetBox'
import LoginLanguageSwitch from '../components/LanguageSwitch/LoginLanguageSwitch'
import BrandLogo from '../components/Header/BrandLogo'
import Infograph from '../components/Infograph/Infograph'
import Footer from '../components/Footer/Footer'
import RegistrationBox from '../components/Registration/RegistrationBox'
import withRouter from '../utils/withRouter'
import IamLoginBanner from '../components/Login/IamLoginBanner'

const mandate = process.env.REACT_APP_MANDATORSET

const LoginPageHeader = styled.div`
  background-position: ${(props) => props.theme.userLogin.backgroundPosition};
  background-size: ${(props) => props.theme.userLogin.backgroundSize};
  background-color: ${(props) => props.theme.userLogin.backgroundColor};

  background-repeat: no-repeat;
  display: block;
  height: 350px;
  width: 100%;
  box-shadow: inset 0 -100px 100px -100px #000000;

  @media screen and (min-width: 1200px) {
    height: 500px;
  }

  background-image: url(${(props) => props.theme.userLogin.backgroundImage});
`

const LoginPageHeaderNav = styled.div`
  height: 75px;
  width: 100%;
`

const LoginPageHeaderContainer = styled.div`
  position: relative;
  background-color: white;
  box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.3);
`

const StyledLoginPageWrapper = styled.div`
  background: white;
  margin-bottom: 200px;
  min-height: 100vh;
  position: relative;
  box-shadow: 0 0 100px 0 rgba(0, 0, 0, 0.8);

  @media screen and (min-width: 1200px) {
    min-height: 100vh;
  }
`

const StyledBox = styled.div`
  .styledBox {
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.3);
    margin-top: -175px;
    margin-right: auto;
    margin-left: auto;
    padding: 20px;

    .form-label {
      color: white;
    }
    .form-text > a {
      color: white;
    }

    @media screen and (min-width: 576px) {
      padding: 30px 40px;
    }

    hr {
      margin-bottom: 2rem;
    }
  }
  .iam-login-box {
    margin-top: -155px;
  }

  .smallBox {
    max-width: 575px;
  }

  .largeBox {
    max-width: 700px;
  }
`
// helper for safe join (keep near top of file)
const buildAuthorizationServerUrl = ({ baseUrl, path }) => {
  if (!baseUrl || !path) return ''

  const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path

  return `${normalizedBaseUrl}${normalizedPath}`
}

//  helper for detecting absolute urls
const isAbsoluteUrl = (value) => /^https?:\/\//i.test(value)

const LoginPage = (props) => {
  const { loginStore, theme, location } = props

  if (!loginStore.initialLogin && loginStore.isUserLoggedIn) {
    return <Navigate to='/' />
  }

  const showIamBanner = Boolean(theme?.userLogin?.showIamBanner)
  const disableLocalLogin = Boolean(theme?.userLogin?.disableLocalLogin)

  const authorizationServerBaseUrl =
    process.env.REACT_APP_AUTHORIZATIONSERVER_URL

  const iamLoginPath = theme?.userLogin?.iamLoginUrl

  const iamHref = authorizationServerBaseUrl
    ? buildAuthorizationServerUrl({
        baseUrl: authorizationServerBaseUrl,
        path: iamLoginPath,
      })
    : isAbsoluteUrl(iamLoginPath)
    ? iamLoginPath
    : iamLoginPath || ''

  if (disableLocalLogin && location.pathname !== '/login') {
    return <Navigate to='/login' />
  }
  return (
    <div className='login-piqo'>
      <div style={{ position: 'relative', zIndex: 2 }}>
        <StyledLoginPageWrapper className='login-piqo'>
          <LoginPageHeaderContainer className='login-piqo'>
            <div className='container-fluid header-piqo'>
              <div className='row'>
                <div className='col'>
                  <LoginPageHeaderNav className='d-flex justify-content-between align-items-center'>
                    <BrandLogo classes='login' />
                    <LoginLanguageSwitch />
                  </LoginPageHeaderNav>
                </div>
              </div>
            </div>
          </LoginPageHeaderContainer>

          {mandate !== 'kliniken' && (
            <LoginPageHeader className='d-flex justify-content-between align-items-center' />
          )}

          <div className='container-fluid login-piqo'>
            <div className='row'>
              <div className='col'>
                <StyledBox className='cws-loginBox'>
                  {/* Securitas -> show IAM banner  */}
                  {showIamBanner && disableLocalLogin && (
                    <IamLoginBanner iamLoginUrl={iamHref} />
                  )}

                  {/* hide local login UI for Securitas */}
                  {!disableLocalLogin && (
                    <>
                      {location.pathname === '/password-reset' && (
                        <PasswordResetBox />
                      )}
                      {location.pathname === '/login' && <LoginBox />}
                      {location.pathname === '/sign-up' && <RegistrationBox />}
                    </>
                  )}
                </StyledBox>

                {theme.contactInfos &&
                  Object.keys(theme.contactInfos).length > 0 && (
                    <ContactInfos />
                  )}
                {mandate !== 'protectus' &&
                  mandate !== 'cws' &&
                  mandate !== 'kliniken' && <Infograph />}
              </div>
            </div>
          </div>
        </StyledLoginPageWrapper>
      </div>

      <Footer />
    </div>
  )
}

export default withTheme(
  withRouter(inject('uiStore', 'loginStore')(observer(LoginPage)))
)
